const  TaskCalendarComponent = {
    templateUrl: '/collaboration/task/taskCalendar/taskCalendar.tpl.html',
    controller: 'taskCalendarController',
    bindings: {
        selectedDate: '<ngModel',
        placeholderText: '<',
        maxDate: '<?',
        minDate: '<?',
        onChange: '&',
        isTimeEnabled: '<?',
        isUtc: '<?'
    }
};

angular.module('gw-um-submission')
    .component('uiTaskCalendar', TaskCalendarComponent);
